import * as api from '../common/api/LoggingApi';

// send error event for logging
export const logErrorMessage = message => {
  try {
    api.logErrorEvent(message)
      .then(response => {
        if (!response.ok) {
          throw new Error(response);
        }
      });
  } catch (error) {
    console.log(`An error occurred when attempting to log frontend errors: ${error.message}`);
  }
};

// send audit event for logging
export const logV2AuditEventMessage = (token, header, service, description, component, action) => {
  const message = {
    service: service,
    type: "INFO",
    description: description,
    component: component,
    action: action,
    timestamp: new Date(Date.now()).toISOString()
  };

  logV2EventMessage(token, header, message)
}

// send event for logging
const logV2EventMessage = (token, header, message) => {
  try {
    api.logV2Event(token, header, JSON.stringify(message))
      .then(response => {
        if (!response.ok) {
          throw new Error(response);
        }
      });
  } catch (error) {
    console.log(`An error occurred when attempting to log frontend errors: ${error.message}`);
  }
};
